import { ErrorCode } from '../atoms/exchange-availability.js';
const initialState = {
    status: null,
    availability: {
        isAvailable: false,
        reason: {
            code: ErrorCode.TemporarilyUnavailable,
        },
    },
    exchangeableAssets: {
        fromAssetIds: [],
        toAssetIds: [],
    },
};
export default initialState;
